import React, {useState} from "react";
import {Field, Form, Formik} from "formik";
import TextField from "@material-ui/core/TextField/TextField";
import Box from "@material-ui/core/Box";
import FormButton from "../../components/buttons/FormButton";
import RequestFeedbackDisplay from "../../components/displays/FeedbackDisplay";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../store";
import {Alert} from "@material-ui/lab";
import services from "../../services/rest/services";
import {Button, Typography} from "@material-ui/core";
import {push} from "connected-react-router";
import Routes from "../../constants/Routes";
import ArrowGoBackLineIcon from "remixicon-react/ArrowGoBackLineIcon";

export interface ForgotPasswordFormProps {
}

export interface ForgotPasswordFormValues {
    email: string;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state: AppState) => state.auth);
    const [sendtRequest, setSendtRequest] = useState<boolean>(false);

    const onSubmit = async (values: ForgotPasswordFormValues) => {
        const response = await services.auth.forgotPassword(values.email);
        if (response.success) {
            setSendtRequest(true);
        }
    };

    const initialValues = {
        email: '',
    };
    return (
        <Box>
            <h2>Nulstil adgangskode</h2>
            <Box pt={2} pb={2} display={'flex'} justifyContent={'flex-start'}>
                <Typography>Indtast din email, så sender vi dig instruktioner om at nulstille din
                    adgangskode</Typography>
            </Box>
            <Formik<ForgotPasswordFormValues> onSubmit={onSubmit} initialValues={initialValues}>
                {({errors, values, touched}) => (
                    <Form>
                        <Field
                            as={TextField}
                            error={errors.email && touched.email && values.email.length !== 0}
                            helperText={values.email.length !== 0 && errors.email}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            name="email"
                            label="Email"
                            type="email"
                            autoComplete="email"
                            autoFocus
                        />

                        <FormButton loading={auth.loading}>
                            Nulstil adgangskode
                        </FormButton>
                        <Box p={2}>
                            <RequestFeedbackDisplay feedback={auth.feedback}/>
                        </Box>
                    </Form>
                )}
            </Formik>
            {sendtRequest && (
                <Alert severity={'success'}>
                    Vi har sendt dig en mail med information om hvordan du nulstiller din adgangskode
                </Alert>
            )}
            <Box width="100%" mt={2} mb={1} display="flex" justifyContent="flex-start" alignItems="center">
                <Button color="primary" onClick={() => {
                    dispatch(push(Routes.landing));
                }}>
                    <ArrowGoBackLineIcon/>
                    <span style={{marginLeft: '4px'}}>Tilbage til log ind</span>
                </Button>
            </Box>
        </Box>
    );
}

export default ForgotPasswordForm;
